/**
 * 응답 데이터에서 Weegloo CDN URL(구 files.weegloo.com / 신 weegloo-media.com)을
 * 자체 프록시(NEXT_PUBLIC_CMS_CDN_BASE_URL) 로 치환.
 * @param data - 응답 데이터 (객체, 배열, 또는 원시값)
 * @returns 치환된 데이터
 */
export const replaceWeeglooCdnUrl = (data: unknown): unknown => {
  const CMS_CDN_BASE_URL = process.env.NEXT_PUBLIC_CMS_CDN_BASE_URL;

  if (typeof data === 'string') {
    if (!CMS_CDN_BASE_URL) return data;
    return data.replace(
      /https:\/\/(?:files\.weegloo\.com|weegloo-media\.com)/g,
      CMS_CDN_BASE_URL,
    );
  }

  if (Array.isArray(data)) {
    return data.map(item => replaceWeeglooCdnUrl(item));
  }

  if (data && typeof data === 'object') {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        replaceWeeglooCdnUrl(value),
      ]),
    );
  }

  return data;
};
